import { DROPDOWN_CONSTANTS, SVG_VIEWBOXES } from './constants';
import styles from './SearchBar.module.css';

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  placeholder: string;
  onFocus: () => void;
  onBlur?: () => void;
  isOpen: boolean;
  onToggle: () => void;
  inputRef: React.RefObject<HTMLInputElement>;
  role?: string;
  'aria-expanded'?: boolean;
  'aria-controls'?: string;
  'aria-activedescendant'?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearchChange,
  placeholder,
  onFocus,
  isOpen,
  onToggle,
  inputRef,
  role,
  'aria-expanded': ariaExpanded,
  'aria-controls': ariaControls,
  'aria-activedescendant': ariaActiveDescendant,
}) => {
  return (
    <div className={styles.searchContainer}>
      <input
        ref={inputRef}
        type="text"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={placeholder}
        className={styles.searchInput}
        onFocus={onFocus}
        role={role}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        aria-activedescendant={ariaActiveDescendant}
      />
      <svg
        className={`${styles.dropdownArrow} ${isOpen ? styles.open : ''}`}
        width={DROPDOWN_CONSTANTS.ARROW_WIDTH}
        height={DROPDOWN_CONSTANTS.ARROW_HEIGHT}
        viewBox={SVG_VIEWBOXES.DROPDOWN_ARROW}
        onClick={onToggle}
        data-testid="dropdown-toggle"
        aria-label="Toggle dropdown"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
        role="button"
      >
        <path
          d="M1 1l5 5 5-5"
          stroke="currentColor"
          strokeWidth={DROPDOWN_CONSTANTS.STROKE_WIDTH}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default SearchBar;
